// DisplayHead.tsx
import "./index.css"

const DisplayHead = ({model}:any) => {
  if(Object.keys(model?model:{}).length === 0){ return (<div></div>)}
  return(
    <div>
      <div className='displayHead' style={{overflowY:'scroll', boxSizing: 'border-box'}}>
        <div className='' style={{whiteSpace: "pre"}}>{JSON.stringify(model?model:{}, null, 2)}</div>
      </div>
    </div>
  )
};
 
export {DisplayHead};